

import axios from "axios";
import toast from "react-hot-toast";

export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

export const DELETE_ATTENDANCE_REQUEST = "DELETE_ATTENDANCE_REQUEST";
export const DELETE_ATTENDANCE_SUCCESS = "DELETE_ATTENDANCE_SUCCESS";
export const DELETE_ATTENDANCE_FAILURE = "DELETE_ATTENDANCE_FAILURE";


const BASE_URL = process.env.REACT_APP_API_BASE_URL;




export const fetchAttendance = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ATTENDANCE_REQUEST });
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({
      page,
      limit,
      district,
      municipality,
      fromDate,
      toDate,
      search,
    }).toString();

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllAttendance?${queryParams}`,
        {
          headers: { authorization: token },
        }
      );

      dispatch({
        type: FETCH_ATTENDANCE_SUCCESS,
        payload: {
          attendance: response.data.data,
          pagination: response.data.pagination,
        },
      });
    } catch (error) {
      let message = "Failed to fetch attendance";
      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_ATTENDANCE_FAILURE,
        payload: message,
      });
    }
  };
};



export const deleteAttendance = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ATTENDANCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(`${BASE_URL}/v1/api/admin/deleteAttendance/${id}`, {
        headers: { authorization: token },
      });

      dispatch({ type: DELETE_ATTENDANCE_SUCCESS, payload: id });

      toast.success("Attendance deleted successfully");

      // Optionally re-fetch the updated list
      // dispatch(fetchAttendance());

    } catch (error) {
      let message = "Failed to delete attendance";
      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: DELETE_ATTENDANCE_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};